export default function (footerSections) {
    return footerSections.map(({ children, name, symbol }) => ({ name, symbol, list: children, type: `footer-${symbol}` }));
}
